import { createSelector } from 'reselect';

import { IMembershipPlanPriceModel } from 'models/MembershipPlanPriceModel';

import { RootState } from '../../index';
import { IAAPricingState } from './index';

export const pricingSelector = (state: RootState) => state.aaPricing;

export const aaMembershipPlansPricesSelector = createSelector(
  pricingSelector,
  (pricing: IAAPricingState): IMembershipPlanPriceModel[] =>
    pricing.membershipPlansPrices,
);
